import findKey from 'lodash/findKey'
import * as ListDataManager from 'dataContainer/listDataManager'

/**
 *
 * @param valueObj
 * @param rowObj
 * @param templateField
 * @param templateFields
 * @returns {*}
 */
export function transformDependentListValue(
  valueObj,
  rowObj,
  templateField,
  templateFields,
  context,
  dataContainer,
  readOnlyTransform,
) {
  if (readOnlyTransform) return valueObj.cell_value

  const listGovernance = getListGovernance(templateField)
  const metadata = listGovernance.meta
  const allTemplateFieldsTiedToList = metadata.allColumnsInList

  // the first template field should be the identifier for dependent lists
  // we assume these have been sorted by the metadata generator
  const firstTemplateFieldInList = allTemplateFieldsTiedToList[0]
  const firstTemplateFieldGovernance = getListGovernance(firstTemplateFieldInList)

  const isMultiselectList = listGovernance.multi || firstTemplateFieldGovernance.multi

  // if we are processing the first column of a dependent list, don't look at other columns
  if (templateField.field_id === firstTemplateFieldInList.field_id) {
    // Sort if multiselect otherwise do nothing
    if (isMultiselectList && valueObj.cell_value) {
      const { delimiter } = firstTemplateFieldGovernance
      return valueObj.cell_value.split(delimiter).sort().join(delimiter)
    }
    return valueObj.cell_value
  }
  if (isMultiselectList) {
    const valueHolder = rowObj[firstTemplateFieldInList.field_id]
    const cellValue = valueHolder.cell_value

    const values = cellValue?.split(firstTemplateFieldGovernance.delimiter) || []
    const rowNumbers = values.map(val => {
      return getRowNumberForSelectedMultiValue(rowObj, firstTemplateFieldInList, val)
    })

    const newValues = rowNumbers.map(rN => {
      return findValueForDependentAtRow(rN, templateField, context)
    })

    return newValues.join(firstTemplateFieldGovernance.delimiter)
  }
  // otherwise we need to populate the value from the row number
  const listRowNumber = getRowNumberForSelectedValue(rowObj, firstTemplateFieldInList)
  const newValue = findValueForDependentAtRow(listRowNumber, templateField, context)
  return newValue
}

function getRowNumberForSelectedValue(rowObj, templateField) {
  const valueHolder = rowObj[templateField.field_id]
  const cellValue = valueHolder.cell_value
  const listGovernance = getListGovernance(templateField)
  const listId = listGovernance.list_id
  const listColumnId = listGovernance.list_column_id
  const indexedRowValues = ListDataManager.getRowNumbersByColumnValue(listId, listColumnId)
  return indexedRowValues[cellValue]
}

/**
 *
 * @param rowObj
 * @param templateField
 */
function getRowNumberForSelectedMultiValue(rowObj, templateField, value) {
  const listGovernance = getListGovernance(templateField)
  const listData = ListDataManager.getListData(listGovernance.list_id)
  const listRows = listData.rowsWithColumnIds
  // const rowNums = listRows.reduce((acc, row) => ({...acc, row[listGovernance.list_column_id]:  }), {})
  const rowNum = findKey(listRows, rowValues => {
    return rowValues[listGovernance.list_column_id] === value
  })

  return rowNum
}

/**
 *
 * @param listRowNumber
 * @param templateField
 * @returns {*}
 */
function findValueForDependentAtRow(listRowNumber, templateField, context) {
  const listGovernance = getListGovernance(templateField)
  const listColumnId = listGovernance.list_column_id
  const listData = ListDataManager.getListData(listGovernance.list_id)
  const listRows = listData.rowsWithColumnIds || {}
  const listRow = listRows[listRowNumber] || {}
  const listValue = listRow[listColumnId]
  // if this is a previously successfully submitted value, it was valid once, so don't clear it on resubmit so we can show a warning.
  if (context.isResubmit && context.originalValue && !listValue) {
    return context.originalValue
  }
  return listValue
}

/**
 *
 * @param templateField
 * @returns {*}
 */
function getListGovernance(templateField) {
  const governanceOwner =
    templateField.field.segment_type === 'variable' ? templateField : templateField.field
  return governanceOwner.list_governance
}
